module.exports = __webpack_public_path__ + "img/Medical_Program_icon03.0487da97.png";